import { render, staticRenderFns } from "./DeleteName.vue?vue&type=template&id=09fda294&"
import script from "./DeleteName.vue?vue&type=script&lang=js&"
export * from "./DeleteName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports